import type { RegionCode } from "brandRegionConfig";
import { useMemo, useState } from "react";
import { useIntlFormatterLocales } from "./useIntlFormatterLocales";
import { useRegion } from "./useRegion";

export const defaultCurrencyOptions: Intl.NumberFormatOptions = {
  style: "currency",
  currencyDisplay: "narrowSymbol",
} as const;

// TODO: Should refactor to have a centralized place for regional configurations
const currencyOptionMap: Record<RegionCode, string> = {
  us: "USD",
  ca: "CAD",
  de: "EUR",
  au: "AUD",
  nz: "NZD",
  mx: "MXN",
};

/**
 * Returns a memoized currency formatter function that formats numbers according to the specified options.
 *
 * @warning Only the initial options will be used. Subsequent changes to the options object will not be reflected in the formatter function.
 */
export function useFormatCurrency(
  options: Intl.NumberFormatOptions = defaultCurrencyOptions,
  region?: RegionCode
) {
  const currentRegion = useRegion();
  const regionToUse = region ?? currentRegion;
  const currency = options.currency ?? currencyOptionMap[regionToUse] ?? "CAD";
  const [initialOptions] = useState({ ...options, currency });
  const locales = useIntlFormatterLocales();
  const formatter = useMemo(
    () => new Intl.NumberFormat(locales, initialOptions).format,
    [initialOptions, locales]
  );
  return formatter;
}
